export default function DesprePage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-12 space-y-16">
        {/* Misiune */}
        <section>
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Misiune</h2>
          <p className="mb-4">
            Promovarea principiilor învăţământului diferenţiat în funcţie de
            nevoile individuale ale elevului:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>
              Asimilarea unor noi meserii în concordanţă cu cerinţele
              comunităţii locale;
            </li>
            <li>
              Creşterea capabilităţii în formare profesională continuă prin
              parteneriate strategice, prin stabilirea unor planuri de acţiuni
              şi proiecte de dezvoltare sinergice şi convergente;
            </li>
            <li>Eliminarea eşecului şi a abandonului şcolar;</li>
            <li>
              Introducerea necesităţii schimbării în plan pragmatic a atitudinii
              şi mentalităţii cadrelor didactice, a elevilor şi a părinţilor;
            </li>
            <li>
              Dezvoltarea infrastructurii şi îmbunătăţirea ambientului şcolar;
            </li>
            <li>Construirea unui sistem de relaţii benefice instituţiei.</li>
          </ul>
        </section>

        {/* Viziune */}
        <section>
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Viziune</h2>
          <p className="text-gray-700 mb-4">
            Liceul Tehnologic „Dr. Florian Ulmeanu” Ulmeni este o şcoală a
            secolului XXI, care urmăreşte dezvoltarea capacităţii de gândire
            creativă şi eficienţă a elevilor săi. Avem la bază conceptul:
          </p>
          <blockquote className="border-l-4 border-gray-300 pl-4 italic text-gray-600 mb-4">
            „Nu pentru şcoală, ci pentru viaţă învăţăm”
            <span className="block mt-2 font-semibold">– Seneca</span>
          </blockquote>
          <p className="text-gray-700">
            Instituţia noastră de învăţământ urmăreşte prin acţiunile sale
            creşterea calităţii vieţii prin oferirea de şanse egale în educaţie,
            creşterea calităţii educaţiei în concordanţă cu cerinţele pieţei
            forţei de muncă din zona Someş Codru şi pregătirea forţei de muncă
            pentru profesiile cerute de piaţa europeană.
          </p>
        </section>

        {/* Ținte strategice */}
        <section>
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Ținte strategice
          </h2>
          <ul className="list-decimal list-inside space-y-2 text-gray-700">
            <li>Îmbunătăţirea calităţii procesului de învăţământ;</li>
            <li>
              Dezvoltarea capacităţii de orientare şcolară şi profesională prin
              asimilarea unor meserii în concordanţă cu cerinţele comunităţii
              şcolare;
            </li>
            <li>
              Construirea unui sistem de relaţii benefice instituţiei prin
              dezvoltarea parteneriatului şcoală – comunitatea locală – agenţi
              economici;
            </li>
            <li>Creşterea capabilităţii în formare profesională continuă;</li>
            <li>Diminuarea eşecului şi a abandonului şcolar;</li>
          </ul>
        </section>

        {/* Istoric */}
        <section>
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Istoric</h2>
          <div className="space-y-4 text-gray-700">
            <p>
              Școala din localitatea Ulmeni s-a înființat în anul 1919, clădirea
              fiind compusă dintr-o sală de clasă și locuinţa învăţătorului. În
              1926 s-a mai adăugat o sală de clasă la şcoala primară, de la
              această dată, aceasta funcţionând cu două săli de învăţământ.
            </p>
            <p>
              În urma stăruinţei reprezentanţilor locali ai învăţământului, în
              primăvara anului 1935 a început construcția grădiniţei pe terenul
              atribuit în acest scop de prin reforma agrară. Lucrarea a fost
              finalizată în anul 1936.
            </p>
            <p>
              Începând cu anul 1950, învăţământul ulmenean continuă să se
              dezvolte atât în ceea ce priveşte efectivul de elevi, cadre
              didactice, cât și ca infrastructură. În anul 1970, şcoala a fost
              extinsă cu 6 săli de clasă și un atelier şcolar.
            </p>
            <p>
              În anul 1998, conform Ordinului Ministrului Educaţiei Naţionale
              nr. 3636 din 24 aprilie 1998, şcoala a primit denumirea de „Dr.
              Florian Ulmeanu”, în cinstea profesorului care a fost mentorul
              multor generaţii școlare.
            </p>
            <p>
              În anul 2001 s-a realizat un proiect de dezvoltare a Grupului
              Şcolar Industrial „Dr. Florian Ulmeanu” pentru perioada 2002–2006,
              incluzând reparaţii şi modernizări ale infrastructurii și
              înființarea a două laboratoare de informatică.
            </p>
            <p>
              În prezent, școala funcţionează cu 14 săli de clasă (din care 7
              sunt cabinete şi laboratoare), laboratoare de fizică, chimie,
              biologie și informatică, bibliotecă cu peste 10.500 volume,
              secretariat dotat, cabinet de asistenţă psihopedagogică, atelier
              mecanic, sală de gimnastică și teren de sport, plus două microbuze
              școlare.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
